import { CONTACT_EMAIL, PRIVACY_URL, TERMS_URL } from "./content";

export const Footer = () => (
  <footer className="footer" data-testid="footer">
    <span>© 2026 She Makes Consistent Cash</span>
    <a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email-link">{CONTACT_EMAIL}</a>
    <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-privacy-link">Privacy Policy</a>
    <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" data-testid="footer-terms-link">Terms</a>
  </footer>
);
